import React from "react";
import { AppTableHeader } from "../../../../Libraries";

const HeaderItem = ({ I18n, fromReturn }) => {
  return (
    <AppTableHeader className={"fiveColumn"}>
      <div className="BoxWidth justifyStart">
        <p className="fontSize12 truncateOneLine newLightColor fontWeight500">
          {I18n.item_name}
        </p>
      </div>
      {!fromReturn && <div className="BoxWidth justifyCenter">
        <p className="fontSize12 truncateOneLine newLightColor fontWeight500">
          {I18n.Variation}
        </p>
      </div>}
      <div className="BoxWidth justifyCenter">
        <p className="fontSize12 truncateOneLine newLightColor fontWeight500">
          {I18n.product_id}
        </p>
      </div>
      <div className="BoxWidth justifyCenter">
        <p className="fontSize12 truncateOneLine newLightColor fontWeight500">
          {fromReturn ? I18n.qty : I18n.order_qty}
        </p>
      </div>
      <div className="BoxWidth justifyCenter">
        <p className="fontSize12 truncateOneLine newLightColor fontWeight500 textCenter">
          {fromReturn ? I18n.evidence : I18n.available_quantity}
        </p>
      </div>
      <div className="BoxWidth justifyCenter">
        <p className="fontSize12 truncateOneLine newLightColor fontWeight500">
          {fromReturn ? I18n.total_order_value : I18n.amount}
        </p>
      </div>
    </AppTableHeader>
  );
};

export default HeaderItem;
